import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-waiting-animation',
    templateUrl: './his-waiting-animation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisWaitingAnimationComponent {
    title = input<string>( '' );
    variant = input<'small' | 'default'>( 'default' );
}
